import { ref } from 'vue';

// Module-level singleton so router + components share the same state
const loading = ref(false);
let finishTimer = null;

export function usePageLoading() {
    function start() {
        clearTimeout(finishTimer);
        loading.value = true;
    }

    function finish() {
        // Brief delay lets the CSS transition reach 100% before hiding
        finishTimer = setTimeout(() => {
            loading.value = false;
        }, 350);
    }

    return { loading, start, finish };
}
